// extracted by mini-css-extract-plugin
module.exports = {"alertMsg":"homepage_alertMsg__2Ru4c","carousel":"homepage_carousel__2zU7k","slickslide":"homepage_slickslide__2wZHK"};